import React, { FC } from 'react';
import {
  Filter,
  TextInput,
  SelectInput,
  DateInput,
  FilterProps,
  ReferenceInput,
} from 'react-admin';
import { LazyReferenceInput } from 'components/LazyAutoCompleteInput';
import { SupervisorReferenceInput } from 'components/SupervisorReferenceInput';
import { UserRoleMultiReferenceInput } from 'components/UserRoleMultiReferenceInput';

export const RepairReceivablesSheetFilter: FC<FilterProps> = props => (
  <Filter {...props}>
    <UserRoleMultiReferenceInput
      source="originalSupervisorUserId"
      roles={['Supervisor', 'SuperAdmin', 'RegionalAdmin']}
      referenceForGetOne="user"
      data-cy="BumpoutTimesheetsFilterSupervisor"
      resettable
      alwaysOn
    />
    <SupervisorReferenceInput
      source="supervisorUserIds||$cont"
      alwaysOn
      resettable
      allowEmpty={false}
      data-cy="masterSheetFilterSupervisor"
    />
    <ReferenceInput
      label="Repair Type"
      data-cy="RepairReceivablesSheetFilterPhase"
      source="repairId"
      reference="repair"
      perPage={Number.MAX_SAFE_INTEGER}
      resettable
      alwaysOn
      allowEmpty={false}
      sort={{ field: 'repairType', order: 'ASC' }}
    >
      <SelectInput optionText="repairType" optionValue="id" />
    </ReferenceInput>
    <DateInput
      label="Repair On or After"
      source="repairDate||$gte"
      alwaysOn
      data-cy="RepairReceivablesSheetFilterDatePaidBegin"
    />
    <DateInput
      label="Repair On or Before"
      source="repairDate||$lte"
      alwaysOn
      data-cy="RepairReceivablesSheetFilterDatePaidEnd"
    />
    <LazyReferenceInput
      label="Builder"
      source="builderId"
      reference="builder"
      resettable
      alwaysOn
      data-cy="RepairReceivablesSheetFilterBuilder"
      filterToQuery={value => (value ? { name: value } : {})}
      sort={{ field: 'name', order: 'ASC' }}
      optionText="name"
      optionValue="id"
    />
    <LazyReferenceInput
      label="Subdivision"
      source="subdivisionId"
      reference="subdivision"
      data-cy="RepairReceivablesSheetFilterSubdivision"
      resettable
      alwaysOn
      filterToQuery={value => (value ? { name: value } : {})}
      sort={{ field: 'name', order: 'ASC' }}
      optionText="name"
      optionValue="id"
    />
    <TextInput
      label="Lot"
      source="jobLot||$eq"
      alwaysOn
      resettable
      data-cy="RepairReceivablesSheetFilterLot"
    />
    <TextInput
      label="Block"
      source="jobBlock||$eq"
      alwaysOn
      resettable
      data-cy="RepairReceivablesSheetFilterBlock"
    />
    <SelectInput
      source="hasPhotos||$eq"
      label="Email Uploaded?"
      alwaysOn
      data-cy="RepairReceivablesSheetFilterhasPhotos"
      choices={[
        { val: true, text: 'Yes' },
        { val: false, text: 'No' },
      ]}
      emptyText="All"
      optionValue="val"
      optionText="text"
    />
    <TextInput
      source="internalInvoice||$eq"
      label="Internal Invoice #"
      resettable
      data-cy="RepairReceivablesSheetFilterInternalInvoice"
    />
    <SelectInput
      source="status||$eq"
      label="Status"
      alwaysOn
      data-cy="RepairReceivablesSheetFilterIsPaid"
      choices={[
        { val: 'Paid', text: 'Paid' },
        { val: 'Unpaid', text: 'Unpaid' },
      ]}
      emptyText="All"
      optionValue="val"
      optionText="text"
    />
    <SelectInput
      source="poReleased||$eq"
      alwaysOn
      label="PO Released"
      data-cy="RepairReceivablesSheetFilterPOReleased"
      choices={[
        { val: true, text: 'Yes' },
        { val: false, text: 'No' },
      ]}
      emptyText="All"
      optionValue="val"
      optionText="text"
    />
    <SelectInput
      source="readyToBook"
      label="Ready to Book"
      data-cy="RepairReceivablesSheetFilterIsReadyToBook"
      choices={[
        { val: true, text: 'Yes' },
        { val: false, text: 'No' },
      ]}
      emptyText="All"
      optionValue="val"
      optionText="text"
      alwaysOn
    />
  </Filter>
);
